import { isEqual } from 'lodash-es';
import type { DependencyList, EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

const useDeepCompareEffect = (effect: EffectCallback, deps: DependencyList): void => {
  const ref = useRef<DependencyList | undefined>(undefined);

  if (!ref.current || !isEqual(deps, ref.current)) {
    ref.current = deps;
  }

  // ref.current only changes identity when deep equality fails, so useEffect re-fires only on meaningful changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, ref.current);
};

export default useDeepCompareEffect;
